var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96094 2.29102V17.7077H16.0443V4.84157L13.4937 2.29102H3.96094ZM2.71094 2.16602C2.71094 1.54469 3.21462 1.04102 3.83594 1.04102H13.5455C13.8439 1.04102 14.13 1.15954 14.341 1.37052L16.9648 3.99429C17.1757 4.20527 17.2943 4.49142 17.2943 4.78979V17.8327C17.2943 18.454 16.7906 18.9577 16.1693 18.9577H3.83594C3.21462 18.9577 2.71094 18.454 2.71094 17.8327V2.16602Z",
    fill: "#EA011D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 8.33268C6.04427 7.9875 6.32409 7.70768 6.66927 7.70768L13.3359 7.70768C13.6811 7.70768 13.9609 7.98751 13.9609 8.33268C13.9609 8.67786 13.6811 8.95768 13.3359 8.95768L6.66927 8.95768C6.32409 8.95768 6.04427 8.67786 6.04427 8.33268Z",
    fill: "#EA011D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 14.9993C6.04427 14.6542 6.32409 14.3743 6.66927 14.3743H13.3359C13.6811 14.3743 13.9609 14.6542 13.9609 14.9993C13.9609 15.3445 13.6811 15.6243 13.3359 15.6243H6.66927C6.32409 15.6243 6.04427 15.3445 6.04427 14.9993Z",
    fill: "#EA011D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 11.666C6.04427 11.3208 6.32409 11.041 6.66927 11.041H10.0026C10.3478 11.041 10.6276 11.3208 10.6276 11.666C10.6276 12.0112 10.3478 12.291 10.0026 12.291H6.66927C6.32409 12.291 6.04427 12.0112 6.04427 11.666Z",
    fill: "#EA011D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3359 1.04102C13.6811 1.04102 13.9609 1.32084 13.9609 1.66602V4.37435H16.6693C17.0144 4.37435 17.2943 4.65417 17.2943 4.99935C17.2943 5.34453 17.0144 5.62435 16.6693 5.62435H13.8359C13.2146 5.62435 12.7109 5.12067 12.7109 4.49935V1.66602C12.7109 1.32084 12.9908 1.04102 13.3359 1.04102Z",
    fill: "#EA011D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRed);
export default __webpack_public_path__ + "static/media/document_red.e1c3d7851241a9326c23c04584c51bf8.svg";
export { ForwardRef as ReactComponent };